import { Component, Input, OnInit } from '@angular/core';
import { ItemProps, ListOptions } from '@app/interfaces';
import { RootService } from '@app/core/root.service';
import { RolesPermissionsService } from '@app/core/permissions/roles-permissions.service';

@Component({
  selector: 'app-list-custom-actions',
  templateUrl: './list-custom-actions.component.html',
  styleUrls: ['./list-custom-actions.component.scss'],
})
export class ListCustomActionsComponent implements OnInit {
  @Input() columns: ItemProps[]; // retrieve from any list component includes the columns data
  @Input() service: RootService;
  @Input() options: ListOptions;
  @Input() row: any;
  hasPermission: boolean = false;
  constructor(public rolesPermissionsService: RolesPermissionsService) {}

  ngOnInit(): void {
    this.hasPermission = this.options.customActions[0]?.dropdownActions?.some(
      (action: any) => action.showPermission === true,
    );
  }
}
